import React from "react";

import PickupSectorCellContent from "../components/PickupSectorCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function pickupSector({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.PickupSector,
		(item) => <PickupSectorCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default pickupSector;
